/** 
 * @type {import("./defs").StoreCluster} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreCluster} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreCluster.js